import React, { ReactElement } from "react";
import { render } from "@testing-library/react";
import { I18nextProvider } from "react-i18next";
import { MemoryRouter } from "react-router-dom";

import i18next from "../i18n";

const routesPath = "/cadastro";

const customRender = (ui: ReactElement, { route = "/cadastro", ...renderOptions }) => {
  window.history.pushState({}, "Test Page", route);

  return render(
    <I18nextProvider i18n={i18next}>
      <MemoryRouter initialEntries={[routesPath]}>{ui}</MemoryRouter>
    </I18nextProvider>,
    renderOptions,
  );
};

const getHours = (date: string, hourSuffix = "", minutesSuffix = "") => {
  const hours = new Date(date)
    .toLocaleTimeString(navigator.language, { hour: "2-digit", minute: "2-digit" })
    .split(":");
  return `${hours[0]}${hourSuffix}${hours[1]}${minutesSuffix}`;
};

const getDate = (date: string, formatOptions?: any) => {
  const createdDate = new Date(date);
  const options = formatOptions || { weekday: "short", year: "numeric", month: "numeric", day: "numeric" };
  return createdDate.toLocaleDateString("pt-br", options).replace(".", "");
};

const getFlightDuration = (departure: string, arrival: string) => {
  const timeStart = new Date(departure).getTime();
  const timeEnd = new Date(arrival).getTime();
  const hourDiff = timeEnd - timeStart; // in ms
  // const secDiff = hourDiff / 1000; //in s
  const minDiff = hourDiff / 60 / 1000; // in minutes
  // const hDiff = hourDiff / 3600 / 1000; //in hours

  return timeConvert(minDiff);
};

const timeConvert = (min: number) => {
  const num = min;
  const hours = num / 60;
  const rHours = Math.floor(hours);
  const minutes = (hours - rHours) * 60;
  const rMinutes = Math.round(minutes);

  // specific format
  return `${rHours}h${rMinutes}min`;
};

export * from "@testing-library/react";

export { customRender as render, getHours, getDate, getFlightDuration };
